import makeStyles from "@mui/styles/makeStyles";
import { Theme } from "@mui/material/styles";

const styles = makeStyles<Theme>((theme) => ({
  maintenanceDiv: {
    fontFamily: "Manrope !important",
    padding: "16px 32px",
  },
  uiTab: {
    minHeight: "calc(100vh - 310px) !important",
    height: "100% !important",
  },
  uiTabCommunication: {
    height: "calc(100vh - 275px) !important",
  },
  ordersTab: {
    maxWidth: "100%",
    overflowX: "hidden",
    overflowY: "hidden",
  },
  ordersHeader: {
    marginBottom: 24,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  idTitle: {
    color: "#465869",
    fontSize: "14px",
    fontWeight: "bold",
  },
  titleContainer: {
    backgroundColor: "#F8F9FC",
    height: "64px",
    boxShadow: "inset 0px -1px 0px #F0F0F0",
    marginBottom: "24px",
    marginTop: "-15px",
    marginLeft: "-32px",
    width: "calc(100% + 64px)",
    padding: "0px 32px",
  },
  title: {
    fontFamile: "Inter",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "20px",
    lineHeight: "24px",
    color: "#38CFC4",
  },
  titleData: {
    color: "#465869",
    fontFamily: "Manrope",
    fontWeight: 700,
    fontSize: "13px",
    lineHeight: "16px",
  },
  titleStatusBadge: {
    height: "24px !important",
    width: "fit-content !important",
    fontFamily: "Manrope",
    marginRight: "8px",
    fontWeight: 600,
    fontSize: "13px",
    lineHeight: "16px",
  },
  titleDataContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-end",
    [theme.breakpoints.down("xs")]: {
      justifyContent: "flex-start",
    },
  },
}));

export default styles;
